import React from 'react';
import ReportsList from './ReportsList';
import './ReportsSidebar.css';

const ReportsSidebar = ({ 
  reports,
  selectedReportId,
  onSelectReport
}) => {
  return (
    <div className="reports-sidebar">
      <div className="sidebar-header">
        <h2>Relatórios</h2>
        <p>Selecione um relatório para executar</p>
      </div>
      
      <ReportsList
        reports={reports}
        selectedReportId={selectedReportId}
        onSelectReport={onSelectReport}
      />
    </div>
  );
};

export default ReportsSidebar;
